import { cn } from '@brew/ui/cn'
import React from 'react'

export type TextShimmerProps = {
  children: React.ReactNode
  as?: React.ElementType
  className?: string
  duration?: number
  spread?: number
  timingFunction?: React.CSSProperties['animationTimingFunction']
  direction?: React.CSSProperties['animationDirection']
  startPosition?: string
  endPosition?: string
}

function TextShimmerComponent({
  children,
  as: Component = 'p',
  className,
  duration = 2,
  spread = 2,
  timingFunction = 'linear',
  direction = 'normal',
  startPosition = '100% center',
  endPosition = '0% center',
}: TextShimmerProps) {
  return React.createElement(
    Component,
    {
      className: cn(
        'relative inline-block bg-size-[250%_100%,auto] bg-clip-text',
        'text-transparent [--base-gradient-color:#000]',
        '[--bg:linear-gradient(90deg,#0000_calc(50%-var(--spread)),var(--base-gradient-color),#0000_calc(50%+var(--spread)))] [background-repeat:no-repeat,padding-box]',
        'dark:[--base-gradient-color:#ffffff] dark:[--bg:linear-gradient(90deg,#0000_calc(50%-var(--spread)),var(--base-gradient-color),#0000_calc(50%+var(--spread)))]',
        className
      ),
      style: {
        '--spread': `${spread}px`,
        '--shimmer-from-position': startPosition,
        '--shimmer-to-position': endPosition,
        backgroundImage:
          'var(--bg), linear-gradient(var(--base-color), var(--base-color))',
        animationName: 'shimmer',
        animationDuration: `${duration}s`,
        animationTimingFunction: timingFunction,
        animationIterationCount: 'infinite',
        animationDirection: direction,
      } as React.CSSProperties,
    },
    children
  )
}

export const TextShimmer = React.memo(TextShimmerComponent)
